// Bobblegifts 购物车管理器 - 优化版本
// 功能：统一管理购物车数据，避免重复请求 cart.js

window.BobblegiftsCartManager = (function() {
  var cartCache = null;
  var cacheTimeout = null;
  var pendingRequests = [];
  var isFetching = false;
  var CACHE_DURATION = 3000; // 缓存 3 秒

  // 获取购物车数据（带缓存）
  function getCart(forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    
    // 如果强制刷新或缓存过期，重新获取
    if (forceRefresh || !cartCache || !cacheTimeout) {
      return fetchCartData();
    }
    
    // 返回缓存数据
    return Promise.resolve(cartCache);
  }

  // 从服务器获取购物车数据
  function fetchCartData() {
    // 如果已经在请求中，加入等待队列
    if (isFetching) {
      return new Promise(function(resolve, reject) {
        pendingRequests.push({ resolve: resolve, reject: reject });
      });
    }
    
    isFetching = true;
    
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(function(response) { 
      if (!response.ok) throw new Error('Network error');
      return response.json(); 
    })
    .then(function(cart) {
      // 更新缓存
      cartCache = cart;
      
      // 清除旧的超时，设置新的
      if (cacheTimeout) clearTimeout(cacheTimeout);
      cacheTimeout = setTimeout(function() {
        cartCache = null;
      }, CACHE_DURATION);
      
      // 处理所有等待的请求
      var requests = pendingRequests;
      pendingRequests = [];
      requests.forEach(function(req) {
        req.resolve(cart);
      });
      
      return cart;
    })
    .catch(function(error) {
      console.error('Error fetching cart:', error);
      
      // 处理所有等待的请求
      var requests = pendingRequests;
      pendingRequests = [];
      requests.forEach(function(req) {
        req.reject(error);
      });
      
      throw error;
    })
    .finally(function() {
      isFetching = false;
    });
  }

  // 检查购物车中是否有指定商品
  function hasProduct(productId) {
    return getCart(false)
      .then(function(cart) {
        return cart.items.some(function(item) { 
          return item.id == productId; 
        });
      })
      .catch(function(error) {
        console.error('Error checking cart for product:', error);
        return false;
      });
  }

  // 获取指定商品的数量
  function getProductQuantity(productId) {
    return getCart(false)
      .then(function(cart) {
        var item = cart.items.find(function(item) { 
          return item.id == productId; 
        });
        return item ? item.quantity : 0;
      })
      .catch(function(error) {
        console.error('Error getting product quantity:', error);
        return 0;
      });
  }

  // 添加商品到购物车
  function addProduct(productId, quantity) {
    if (quantity === void 0) quantity = 1;
    
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      // 更新缓存
      cartCache = cart;
      return cart;
    })
    .catch(function(error) {
      console.error('Error adding product:', error);
      throw error;
    });
  }

  // 更新购物车商品数量
  function changeProductQuantity(productId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      // 更新缓存
      cartCache = cart;
      return cart;
    })
    .catch(function(error) {
      console.error('Error changing product quantity:', error);
      throw error;
    });
  }

  // 强制刷新缓存
  function refreshCache() {
    return fetchCartData();
  }

  // 清除缓存
  function clearCache() {
    if (cacheTimeout) clearTimeout(cacheTimeout);
    cartCache = null;
  }

  // 公开方法
  return {
    getCart: getCart,
    hasProduct: hasProduct,
    getProductQuantity: getProductQuantity,
    addProduct: addProduct,
    changeProductQuantity: changeProductQuantity,
    refreshCache: refreshCache,
    clearCache: clearCache
  };
})();

// 添加全局事件监听，当购物车变化时清除缓存
document.addEventListener('bobblegifts-shipping-insurance-changed', function() {
  window.BobblegiftsCartManager.clearCache();
});

document.addEventListener('bobblegifts-vip-service-changed', function() {
  window.BobblegiftsCartManager.clearCache();
});
